export default class Product {
    id;
    ref;
    code;
    title;
    description;
}